export interface CarService {
  id: number;
  name: string;
  desc: string;
  duration: string;
  enabled: boolean;
}

export const carServices: CarService[] = [
  { id: 1, name: "غسل خارجي", desc: "غسل الهيكل والعجلات بمواد آمنة", duration: "20 دقيقة", enabled: true },
  { id: 2, name: "غسل خارجي وداخلي", desc: "غسل كامل مع تنظيف وتلميع داخلي", duration: "40 دقيقة", enabled: true },
  { id: 3, name: "تلميع كامل", desc: "تلميع خارجي بمواد فاخرة وحماية", duration: "60 دقيقة", enabled: true },
  { id: 4, name: "تنظيف محرك", desc: "تنظيف المحرك وتعقيمه بالبخار", duration: "30 دقيقة", enabled: false },
];

export const vehicleTypes = ["صغيرة", "سيدان", "SUV", "بيك أب", "فان"];

export interface PriceRow {
  service: string;
  prices: string[];
}

export const carPriceGrid: PriceRow[] = [
  { service: "غسل خارجي", prices: ["20", "25", "30", "35", "40"] },
  { service: "غسل خارجي وداخلي", prices: ["35", "45", "55", "65", "75"] },
  { service: "تلميع كامل", prices: ["80", "120", "150", "180", "200"] },
  { service: "تنظيف محرك", prices: ["40", "50", "60", "70", "80"] },
];

export interface CarOption {
  id: number;
  name: string;
  price: string;
  enabled: boolean;
}

export const carOptions: CarOption[] = [
  { id: 1, name: "تنظيف وتلميع الجنوط", price: "15", enabled: true },
  { id: 2, name: "تعقيم داخلي", price: "20", enabled: true },
  { id: 3, name: "إزالة خدوش خفيفة", price: "35", enabled: false },
  { id: 4, name: "حماية الزجاج الأمامي", price: "25", enabled: false },
];

export interface HomeElement {
  id: number;
  name: string;
  price: string;
  enabled: boolean;
}

export const homeElements: HomeElement[] = [
  { id: 1, name: "غرفة نوم", price: "50", enabled: true },
  { id: 2, name: "غرفة نوم مع حمام", price: "70", enabled: true },
  { id: 3, name: "صالة", price: "60", enabled: true },
  { id: 4, name: "مجلس", price: "55", enabled: true },
  { id: 5, name: "مطبخ", price: "80", enabled: true },
  { id: 6, name: "دورة مياه", price: "35", enabled: true },
];

export interface GarmentService {
  name: string;
  price: string;
  enabled: boolean;
}

export interface Garment {
  id: number;
  name: string;
  icon: string;
  enabled: boolean;
  hasOptions?: boolean;
  options?: string[];
  services: GarmentService[];
}

export const garments: Garment[] = [
  {
    id: 1,
    name: "ثوب",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [
      { name: "غسيل وكوي", price: "12", enabled: true },
      { name: "كوي فقط", price: "7", enabled: true },
      { name: "تنظيف جاف", price: "20", enabled: true },
    ],
  },
  {
    id: 2,
    name: "قميص",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [
      { name: "غسيل وكوي", price: "9", enabled: true },
      { name: "كوي فقط", price: "5", enabled: true },
      { name: "تنظيف جاف", price: "15", enabled: true },
    ],
  },
  {
    id: 3,
    name: "شماغ / غترة",
    icon: "ri-scissors-line",
    enabled: true,
    hasOptions: true,
    options: ["نشا", "مكوي عادي"],
    services: [
      { name: "غسيل وكوي", price: "8", enabled: true },
      { name: "كوي فقط", price: "5", enabled: true },
    ],
  },
  {
    id: 4,
    name: "بنطلون",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [
      { name: "غسيل وكوي", price: "10", enabled: true },
      { name: "كوي فقط", price: "6", enabled: true },
      { name: "تنظيف جاف", price: "16", enabled: true },
    ],
  },
  {
    id: 5,
    name: "عباءة",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [
      { name: "غسيل وكوي", price: "14", enabled: true },
      { name: "كوي فقط", price: "8", enabled: true },
    ],
  },
  {
    id: 6,
    name: "فستان",
    icon: "ri-t-shirt-line",
    enabled: false,
    services: [
      { name: "غسيل وكوي", price: "18", enabled: true },
      { name: "تنظيف جاف", price: "25", enabled: true },
    ],
  },
  {
    id: 7,
    name: "بشت",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [
      { name: "غسيل وكوي", price: "20", enabled: true },
      { name: "تنظيف جاف", price: "30", enabled: true },
    ],
  },
  {
    id: 8,
    name: "بطانية",
    icon: "ri-t-shirt-line",
    enabled: true,
    services: [{ name: "غسيل", price: "25", enabled: true }],
  },
];

export interface WashType {
  id: number;
  name: string;
  mode: "base" | "percent" | "per-garment";
  value: string;
}

export const washTypes: WashType[] = [
  { id: 1, name: "عادي", mode: "base", value: "السعر الأساسي (بدون زيادة)" },
  { id: 2, name: "مستعجل", mode: "percent", value: "50%" },
  { id: 3, name: "بخار", mode: "per-garment", value: "تعديل" },
  { id: 4, name: "جاف", mode: "per-garment", value: "تعديل" },
];

export interface DeliveryMode {
  name: string;
  price: string;
  duration: string;
}

export const delivery: DeliveryMode[] = [
  { name: "عادي", price: "15", duration: "48-72 ساعة" },
  { name: "مستعجل", price: "25", duration: "24 ساعة" },
];